module.exports = __webpack_public_path__ + "img/kreco_phone.117e466d.jpg";